module.exports = __webpack_public_path__ + "static/media/van front.b819a0ac.png";